module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agentarea"
  }, [_c('el-dialog', {
    attrs: {
      "title": "",
      "size": "large",
      "visible": _vm.editVisibleList,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisibleList = $event
      },
      "close": _vm.dgclosecallback
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "代理区域",
      "name": "tab1"
    }
  }, [_c('div', {
    staticClass: "mg10"
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.AreaList,
      "border": "",
      "size": "full"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContractNumber",
      "label": "合同号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StartDate",
      "label": "代理开始时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "EndDate",
      "label": "代理到期时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProjectTypeName",
      "label": "项目类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政策2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [_c('span', [_vm._v(_vm._s(_vm.getPolicyName(scoped.row.PolicyType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代理区域",
      "prop": "AreaLists"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AgentLevelName",
      "label": "代理商级别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProxyTypeName",
      "label": "代理类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContractStatusName",
      "label": "合同状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "opt-templ"
        }, [_c('el-button', {
          attrs: {
            "icon": "",
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.viewHtztByAreaId(scope.row)
            }
          }
        }, [_vm._v("查看合同状态")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "合同状态",
      "name": "tab2"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.htztList,
      "border": "",
      "size": "full"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContractNumber",
      "label": "合同号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContractStatusName",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收件人"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [(scoped.row.Consignee != '') ? _c('span', [_vm._v(_vm._s(scoped.row.Consignee))]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收件人电话"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [(scoped.row.ConsigneeTel != '') ? _c('span', [_vm._v(_vm._s(scoped.row.ConsigneeTel))]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ConsigneeTime",
      "label": "寄出/收件日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LogisticsCode",
      "label": "快递或物流单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "快递或物流名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [(scoped.row.LogisticsName != '') ? _c('span', [_vm._v(_vm._s(scoped.row.LogisticsName))]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "opt-templ"
        }, [_c('el-button', {
          attrs: {
            "icon": "",
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.viewHtzt(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "icon": "edit",
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.delHtzt(scope.row)
            }
          }
        }, [_vm._v("删除")])], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editVisibleList = false
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      },
      "close": _vm.callback
    }
  }, [_vm._l((_vm.agentList), function(agent, index) {
    return _c('agent-info', {
      ref: 'agentInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "value": agent,
        "isPerson": _vm.isPerson
      }
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onlyLookAgentInfo),
      expression: "!onlyLookAgentInfo"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.submitBtn
    },
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v("确 定")])], 1)], 2), _vm._v(" "), _c('operateAddressDialog', {
    ref: "refOperateAddressDialog",
    attrs: {
      "value": _vm.agentDeliveryAddress
    },
    on: {
      "selectAddress": _vm.selectAddress
    }
  }), _vm._v(" "), _c('optContractStatus', {
    ref: "refoptContractStatus",
    on: {
      "reloadZtList": _vm.reloadZtList
    }
  }), _vm._v(" "), _c('viewContractStatusListDialog', {
    ref: "refviewContractStatusListDialog"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0de2a1b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/CRMFormatAgent/components/agentArea/index.vue
// module id = 1380
// module chunks = 1